import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import { WhoWeAreOverview, Leadership, PresidentsMessage } from "./pages/WhoWeAre";
import { WhatWeDoOverview, ServiceDetail } from "./pages/WhatWeDo";
import { WhoWeServeOverview, AudienceDetail, WhyWeStandOut } from "./pages/WhoWeServe";
import Contact from "./pages/Contact";
import ReviewRequest from "./pages/ReviewRequest";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/who-we-are" element={<WhoWeAreOverview />} />
            <Route path="/who-we-are/leadership" element={<Leadership />} />
            <Route path="/who-we-are/presidents-message" element={<PresidentsMessage />} />
            <Route path="/what-we-do" element={<WhatWeDoOverview />} />
            <Route path="/what-we-do/:slug" element={<ServiceDetail />} />
            <Route path="/who-we-serve" element={<WhoWeServeOverview />} />
            <Route path="/who-we-serve/:slug" element={<AudienceDetail />} />
            <Route path="/why-we-stand-out" element={<WhyWeStandOut />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/nonprofit-review" element={<ReviewRequest />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
